import { SxProps, Theme } from '@mui/material';

export const confirmationContainerSX: SxProps<Theme> = {
	py: 3,
	textAlign: 'center',
};

export const confirmationIconBoxSX: SxProps<Theme> = {
	color: 'success.main',
	display: 'flex',
};
